var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sidebarComponent)?_c(_vm.sidebarComponent,{tag:"component"}):_vm._e(),(_vm.isToolBarVisible && !_vm.sidebarComponent)?_c('app-tools'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }